import { render, staticRenderFns } from "./personalInformationForm.vue?vue&type=template&id=5b0c5ab7&scoped=true"
import script from "./personalInformationForm.vue?vue&type=script&lang=js"
export * from "./personalInformationForm.vue?vue&type=script&lang=js"
import style0 from "./personalInformationForm.vue?vue&type=style&index=0&id=5b0c5ab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c5ab7",
  null
  
)

export default component.exports